import { useApiVersion } from '@/feature/version'

export const useVersionInfo = (options: Parameters<typeof useApiVersion>[0] = {}) => {
  const { data, error } = useApiVersion(options)

  return {
    version: data.version,
    buildId: data.buildId,
    error,
    latest: data.buildId === process.env.NEXT_PUBLIC_BUILD_ID,
  }
}
